export const mergeArrayByKey = (combinedList, key) => {
  const list = combinedList.reduce((acc, item) => {
    const keyValue = item[key];
    const prevItem = acc[keyValue] || {};

    acc[keyValue] = {
      ...prevItem,
      ...item,
    };

    return acc;
  }, {});

  return Object.values(list);
};
